import React from 'react';
import AutomationPostModalBackButton from 'components/AutomationPostModalBackButton';
import SocialShareModalBody from 'containers/SocialShareModal/SocialShareModalBody';
import useSocialPostShareStatus from 'containers/SocialShareModal/SocialSharePlatforms/useSocialPostShareStatus';
import { socialShareModalBlock as block } from 'containers/SocialShareModal/utils';
import TagsInput from 'containers/YoutubePostModal/TagsInput';
import { TagsProps } from 'containers/YoutubePostModal/TagsInput/types';
import YoutubeCategorySelector, {
  YoutubeCategorySelectorProps,
} from 'containers/YoutubePostModal/YoutubeCategorySelector';
import YoutubeLanguageSelector, {
  YoutubeLanguageSelectorProps,
} from 'containers/YoutubePostModal/YoutubeLanguageSelector/YoutubeLanguageSelector';
import YoutubeSettings from 'containers/YoutubePostModal/YoutubeSettings';
import { YoutubeVisibilitySelectorProps } from 'containers/YoutubePostModal/YoutubeVisibilitySelector';

export type YouTubeAdditionalDetailsStepProps = {
  visibility: YoutubeVisibilitySelectorProps['value'];
  madeForKids: boolean;
  categories: YoutubeCategorySelectorProps['options'];
  categoryId: YoutubeCategorySelectorProps['value'];
  languages: YoutubeLanguageSelectorProps['languageOptions'];
  language: YoutubeLanguageSelectorProps['value'];
  tags: TagsProps['defaultValue'];
  onVisibilityChange: YoutubeVisibilitySelectorProps['onChange'];
  onMadeForKidsChange: (value: boolean) => void;
  onCategoryIdChange: YoutubeCategorySelectorProps['onChange'];
  onLanguageChange: YoutubeLanguageSelectorProps['onChange'];
  onTagsChange: TagsProps['onChange'];
  onClickBack: () => void;
  resetComposerValues: () => void;
};

const YouTubeAdditionalDetailsStep: React.FC<YouTubeAdditionalDetailsStepProps> = ({
  visibility,
  madeForKids,
  categories,
  categoryId,
  languages,
  language,
  tags,
  onVisibilityChange,
  onMadeForKidsChange,
  onCategoryIdChange,
  onLanguageChange,
  onTagsChange,
  onClickBack,
  resetComposerValues,
}) => {
  useSocialPostShareStatus({
    onSuccess: resetComposerValues,
  });

  return (
    <SocialShareModalBody
      showHeader={false}
      className={block('step-contents-container')}
    >
      <AutomationPostModalBackButton
        text="Additional details"
        onClick={onClickBack}
      />

      <YoutubeSettings
        madeForKids={madeForKids}
        onMadeForKidsChange={onMadeForKidsChange}
        onVisibilityChange={onVisibilityChange}
        visibility={visibility}
      />

      <YoutubeCategorySelector
        options={categories}
        onChange={onCategoryIdChange}
        value={categoryId}
      />

      <YoutubeLanguageSelector
        languageOptions={languages}
        onChange={onLanguageChange}
        value={language}
      />

      <TagsInput defaultValue={tags} onChange={onTagsChange} />
    </SocialShareModalBody>
  );
};

export default YouTubeAdditionalDetailsStep;
